import * as types from "../../actions/ActionTypes";
const initialState = {
    loading: false,
    data: null,
    error: null,
};

const getCurrentUserDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CURRENT_USER_GET_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.CURRENT_USER_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.CURRENT_USER_GET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case types.UPDATE_USER_DETAILS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.UPDATE_USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    ...action.payload,
                    profile_picture: action.payload.profile_picture
                },
                error: null,
            };

        case types.UPDATE_USER_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case types.CURRENT_USER_GET_RESET:
        case types.LOGOUT_SUCCESS:
            return initialState;

        default:
            return state;
    }
};

export default getCurrentUserDetailsReducer;
